module.exports = __webpack_public_path__ + "media/images/emblems/Nuvilly-coat_of_arms-4af56335b0787fd79c71a169e8cc883f.svg";